import { useEffect } from 'react'

/**
 * Hook that resets scroll position to the top when the component mounts.
 * Useful for fixing scroll position issues when navigating between pages.
 */
export function useScrollReset(): void {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
}
